import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import {
  CreateActionTaskGQL,
  CreateActionTaskMutation,
  CreateActionTaskMutationVariables,
  RemoveActionTaskGQL,
  RemoveActionTaskMutation,
  RemoveActionTaskMutationVariables,
  UpdateActionTaskStatusGQL,
  UpdateActionTaskStatusMutation,
  UpdateActionTaskStatusMutationVariables,
} from "src/generated/graphql";
import { DeleteActionMutation } from "src/generated/graphql/idea/action/action.graphql";

@Injectable({
  providedIn: "root",
})
export class ActionTasksService {
  constructor(
    private createActionTaskGQL: CreateActionTaskGQL,
    private updateActionTaskStatusGQL: UpdateActionTaskStatusGQL,
    private removeActionTaskGQL: RemoveActionTaskGQL
  ) {}

  createActionTask({
    input,
  }: CreateActionTaskMutationVariables): Observable<CreateActionTaskMutation> {
    return this.createActionTaskGQL.mutate({ input }).pipe(
      map((result: { data: CreateActionTaskMutation }) => {
        return result.data;
      }),
      catchError(() => {
        return throwError(() => new Error("Failed to create task"));
      })
    );
  }

  updateActionTaskStatus({
    id,
  }: UpdateActionTaskStatusMutationVariables): Observable<UpdateActionTaskStatusMutation> {
    return this.updateActionTaskStatusGQL.mutate({ id }).pipe(
      map((result: { data: UpdateActionTaskStatusMutation }) => {
        return result.data;
      }),
      catchError(() => {
        return throwError(() => new Error("Failed to update task"));
      })
    )
  }

  removeActionTask({
    id,
  }: RemoveActionTaskMutationVariables): Observable<RemoveActionTaskMutation> {
    return this.removeActionTaskGQL.mutate({ id }).pipe(
      map((result: {data: RemoveActionTaskMutation}) => {
        return result.data
      }),
      catchError(() => {
        return throwError(() => new Error("Failed to remove task"));
      })
    )
  }
}
